import { Route as SalesHistoryRoute } from "@/routes/(inventory)/branch/_layout/sales_history/index";
import { useQuery } from "@tanstack/react-query";
import { getSalesHistory } from "../-data/api";

interface SalesHistoryQueryResult {
  sales_history: any;
  users: any[];
}

export const useSalesHistoryData = () => {
  const searchParams = SalesHistoryRoute.useSearch();
  
  return useQuery<SalesHistoryQueryResult>({
    queryKey: ["sales-history", searchParams],
    queryFn: async () => {
      return await getSalesHistory(
        searchParams.page || 1,
        searchParams.pageSize || 10,
        searchParams.userID,
        searchParams.startDate,
        searchParams.endDate,
        searchParams.type
      );
    },
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};